"use client";

import { poppins_body_sm_medium } from "@frontend/design-system";
import styled from "styled-components";

export const ErrorMessage = styled.div`
  padding-top: 0.4rem;
  color: var(--Color-Common-Text-Warning, #e53e06);
  ${poppins_body_sm_medium}
`;
